import script from "./FormulasIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredients.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredients.vue?vue&type=style&index=0&id=87875884&lang=scss"

const __exports__ = script;

export default __exports__